import type { PaletteOptions } from '@mui/material';

export const buildPalette = (): PaletteOptions => ({
  background: {
    default: '#F8F9FA',
  },
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  error: {
    main: '#F44336',
    light: '#FEECEB',
    dark: '#9D160C',
  },
  info: {
    main: '#2196F3',
    light: '#E8F4FE',
    dark: '#004780',
  },
  warning: {
    main: '#ED6C02',
    light: '#FDF0E5',
    dark: '#A94E03',
    80: '#F08934',
    60: '#F4A667',
    40: '#F7C499',
  },
  success: {
    main: '#4CAF50',
    light: '#EDF7ED',
    dark: '#0A5C0E',
  },
  accent: {
    main: '#D9BEFF',
    light: '#98A1A8', // primary90
    dark: '#2D3B46', // primary50
    contrastText: '#FFFFFF',
  },
  primary: {
    main: '#1F2E3A', // primary100
    light: '#2D3B46',
    dark: '#071724',
    contrastText: '#FFFFFF',
    90: '#2D3B46',
    80: '#46535D',
    70: '#626E77',
    60: '#7D8890',
    50: '#98A1A8',
    40: '#B0B8BE',
    30: '#CCD2D7',
    20: '#E5E9ED',
    10: '#F8F9FA',
  },
  secondary: {
    main: '#6DBAE8', // secondary100
    light: '#7CC2EB',
    dark: '#3E9AD1',
    contrastText: '#FFFFFF',
    80: '#7CC2EB',
    60: '#9AD0F0',
    50: '#B8DEF4',
    30: '#D5EBF9',
    10: '#EFF8FD',
  },
  tertiary: {
    main: '#626E77', // primary70
    light: '#98A1A8', // primary90
    dark: '#2D3B46', // primary50
    contrastText: '#FFFFFF',
  },
});
